
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/element",
      function () {
        return require("private-next-pages/element.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/element"])
      });
    }
  